import React, { useState, useCallback, useEffect } from 'react';
import classnames from 'classnames/bind';
import { Header, Text, Button, Input, Actions, Link } from '@gasbuddy/react-components';
import styles from './EditMembernameStatus.module.css';
import { isValidMemberName } from '../../../lib/utils';

const cx = classnames.bind(styles);

export const USERNAME_STATE = {
  EDITABLE: 1,
  CUSTOMIZED: 2,
  UPDATED: 3,
};

export default function EditMembernameStatus({ error, isLoading, memberName, onClose, onFinish, onSubmit, onReset, variant }) {
  const [membername, setMembername] = useState(memberName || '');
  const [memberNameError, setMemberNameError] = useState();

  useEffect(() => {
    setMemberNameError(error);
  }, [error]);

  const onMembernameChange = useCallback((e) => {
    e.preventDefault();
    onReset();
    setMemberNameError(undefined);
    setMembername(e.target.value);
  }, [onReset]);

  const handleOnSubmit = useCallback(() => {
    if (membername.length < 5 || membername.length > 15) {
      setMemberNameError('Username must be between 5 and 15 characters long');
      return;
    }

    if (!isValidMemberName(membername)) {
      setMemberNameError('Username cannot include special characters');
      return;
    }
    onReset();
    onSubmit(membername);
  }, [membername, onSubmit, onReset]);

  const isDisabled = isLoading || !membername;

  switch (variant) {
    case USERNAME_STATE.EDITABLE: {
      return (
        <React.Fragment>
          <Header as="h3">Edit your username</Header>
          <Text as="p" className={cx('textSpacer')}>
            Choose a username that other GasBuddy members will see.
            You can only set your username once.
            No pressure.
            You got this!
          </Text>
          <Input
            className={cx('memberNameInput')}
            value={membername}
            onChange={onMembernameChange}
            error={memberNameError}
            placeholder="Enter New Username"
          />
          <br />
          <Actions>
            <Actions.Button
              primary
              fluid
              onClick={handleOnSubmit}
              loading={isLoading}
              disabled={isDisabled}
              desktop={6}
            >
              Set Username
            </Actions.Button>
            <Actions.Action desktop={4}>
              <Link onClick={onClose} uppercase>
                Cancel
              </Link>
            </Actions.Action>
          </Actions>
        </React.Fragment>
      );
    }

    case USERNAME_STATE.UPDATED: {
      return (
        <React.Fragment>
          <Header as="h3">Username updated!</Header>
          <Text as="p">
            {membername} has a nice ring to it!
          </Text>
          <br />
          <Button primary wide onClick={onFinish}>
            Done
          </Button>
        </React.Fragment>
      );
    }

    case USERNAME_STATE.CUSTOMIZED: {
      return (
        <React.Fragment>
          <Header as="h3">You’ve already set your username.</Header>
          <Text as="p">
            Unfortunately, you can only personalize your username once.
          </Text>
          <br />
          <Button primary wide onClick={onClose}>Okay</Button>
        </React.Fragment>
      );
    }

    default: {
      return false;
    }
  }
}
